module.exports = __webpack_public_path__ + "img/create-your-own.c4f59d5.png";